import FilterRefinementList from '@/components/filters/FilterRefinementList'
import FilterRefinementIconList from '@/components/filters/FilterRefinementIconList'
import FilterHierarchicalMenu from '@/components/filters/FilterHierarchicalMenu'
import FilterDatepicker from '@/components/filters/FilterDatepicker'

export type FilterModalComponentsProps = {
  filters: {
    heading: string
    attribute: string
    attributes?: string[]
    type: 'refinementList' | 'refinementIconList' | 'hierarchicalMenu' | 'date'
  }[]
}

export default function FilterModalComponents({ filters }: FilterModalComponentsProps) {
  if (!filters?.length) {
    return null
  }

  const renderComponents = filters.map(({ heading, attribute, attributes, type }) => {
    const isRadio = type === 'hierarchicalMenu' || false

    if (type === 'refinementIconList') {
      return (
        <FilterRefinementIconList
          key={heading}
          heading={heading}
          attribute={attribute}
          radio={isRadio}
        />
      )
    }

    if (type === 'hierarchicalMenu') {
      return <FilterHierarchicalMenu key={heading} heading={heading} attributes={attributes} />
    }

    if (type === 'date') {
      return <FilterDatepicker key={heading} heading={heading} />
    }

    return <FilterRefinementList key={heading} heading={heading} attribute={attribute} />
  })

  return <div className="mx-[-1px] flex flex-wrap">{renderComponents}</div>
}
